<template>
  <div class="date-fields">
    <div class="form-group">
      <span>{{ $t('messages.start_date') }}</span>
      <input type="date" v-model="localStart" class="form-input" :class="{ 'input-invalid': startError }"
        :min="startMin" :max="campaignEnd" @input="emitUpdate" />
      <div v-if="startError" class="field-error">{{ startError }}</div>
    </div>

    <div class="form-group">
      <span>{{ $t('messages.end_date') }}</span>
      <input type="date" v-model="localEnd" class="form-input" :class="{ 'input-invalid': endError }"
        :min="localStart || startMin" :max="campaignEnd" @input="emitUpdate" />
      <div v-if="endError" class="field-error">{{ endError }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdGroupDates',
  props: {
    startDate: { type: [String, null], default: null },
    endDate: { type: [String, null], default: null },
    campaignStart: { type: [String, null], default: null },
    campaignEnd: { type: [String, null], default: null }
  },
  data() {
    return {
      localStart: this.startDate || null,
      localEnd: this.endDate || null
    };
  },
  watch: {
    startDate(val) { this.localStart = val; },
    endDate(val) { this.localEnd = val; }
    ,
    campaignStart() { this.clampToCampaign(); },
    campaignEnd() { this.clampToCampaign(); }
  },
  methods: {
    clampToCampaign() {
      // Ensure local dates stay within campaign bounds
      const cs = this.campaignStart || null;
      const ce = this.campaignEnd || null;
      if (cs) {
        if (!this.localStart || this.localStart < cs) this.localStart = cs;
      }
      if (ce) {
        if (!this.localEnd || this.localEnd > ce) this.localEnd = ce;
      }
      if (this.localStart && this.localEnd && this.localStart > this.localEnd) {
        this.localEnd = this.localStart;
      }
      this.emitUpdate();
    },
    emitUpdate() {
      // simple validation only — emit values, do not modify them here
      this.$emit('update-dates', { start_date: this.localStart || null, end_date: this.localEnd || null });
    }
  },
  computed: {
    todayString() {
      const d = new Date();
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    },
    startMin() {
      // start cannot be before today and cannot be before campaign start
      if (this.campaignStart) {
        return this.campaignStart > this.todayString ? this.campaignStart : this.todayString;
      }
      return this.todayString;
    },
    startError() {
      if (!this.localStart) return null;
      if (this.localStart < this.startMin) return this.$t ? this.$t('messages.error_start_date_before_today') : 'Дата начала не может быть раньше разрешённой даты';
      if (this.campaignEnd && this.localStart > this.campaignEnd) return this.$t ? this.$t('messages.error_start_date_after_campaign_end') : 'Дата начала не может быть позже конца кампании';
      return null;
    },
    endError() {
      if (!this.localEnd) return null;
      if (this.localStart && this.localEnd < this.localStart) return this.$t ? this.$t('messages.error_end_date_before_start') : 'Дата окончания не может быть раньше даты начала';
      if (this.campaignEnd && this.localEnd > this.campaignEnd) return this.$t ? this.$t('messages.error_end_date_after_campaign_end') : 'Дата окончания не может быть позже конца кампании';
      if (this.campaignStart && this.localEnd < this.campaignStart) return this.$t ? this.$t('messages.error_end_date_before_campaign_start') : 'Дата окончания не может быть раньше начала кампании';
      return null;
    }
  }
};
</script>

<style scoped>
.date-fields {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.date-fields .form-group {
  flex: 1;
  min-width: 180px;
}

.field-error {
  color: #c00;
  margin-top: 6px;
  font-size: 13px;
}

.input-invalid {
  border-color: #c00;
  box-shadow: 0 0 0 1px rgba(200, 0, 0, 0.08);
}
</style>
